/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function getNativeCartCount() {
    return Array.from(document.querySelectorAll('[data-cart-drawer] [data-quantity-field]'))
      .reduce(function(total, input) {
        return total + (parseInt(input.value, 10) || 0);
      }, 0);
  }

  function updateGinyhomeCartCounts() {
    var count = getNativeCartCount();
    document.querySelectorAll('[data-ginyhome-cart-count]').forEach(function(element) {
      if (element.classList.contains('ginyhome-header-cart-count')) {
        element.textContent = count;
        element.classList.toggle('hidden', count === 0);
      } else {
        element.textContent = count + (count === 1 ? ' articolo nel carrello' : ' articoli nel carrello');
      }
    });
  }

  // Releasit injects a second quantity field into the native product form.
  // Keep the selected storefront quantity authoritative for Shopify's add-to-cart payload.
  document.addEventListener('formdata', function(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[data-product-form]')) return;

    var quantityField = form.querySelector('[data-quantity-field][name="quantity"]');
    if (quantityField && quantityField.value !== '') {
      event.formData.set('quantity', quantityField.value);
    }
  });

  document.addEventListener('theme:cart:added', updateGinyhomeCartCounts);
  document.addEventListener('theme:cart:loaded', updateGinyhomeCartCounts);
  document.addEventListener('click', function(event) {
    var continueLink = event.target.closest('.ginyhome-cart-continue');
    if (!continueLink) return;

    event.preventDefault();
    var closeButton = document.querySelector('.cart-drawer__close[data-cart-drawer-toggle]');
    if (closeButton) closeButton.click();
  });







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
